define(function(require, exports, module) {
    'use strict';
    var I18nUtil = require('util/i18n.util');

    module.exports = new I18nUtil();
});